import '@fuze/design-system/dist/styles.css';
import '@fuze/styled-system/styles.css';
import './fonts';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { bootApp } from './app/boot';
import { loadRuntimeConfig } from './app/config';
import { createAppRouter } from './app/router';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

const services = bootApp(loadRuntimeConfig());
const router = createAppRouter();

createRoot(container).render(
  <StrictMode>
    <App
      services={services}
      router={router}
    />
  </StrictMode>,
);
